import React from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";

import { MailPreference, mailLabelTypeTranslationMapping } from "@/models/MailPreferenceModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

type MailPreferenceItemType = {
  mail: MailPreference;
  className?: string;
};

export const MailPreferenceItem: React.FC<MailPreferenceItemType> = ({ mail, className }) => {
  const { t } = useTranslation();

  const updatePreference = Queries.mailPreference.useUpdatePreference();
  const clickHandler = () => {
    updatePreference.mutate({ id: mail.id, enabled: !mail.enabled });
  };

  const label = t(mailLabelTypeTranslationMapping(mail.label));

  return (
    <div
      id={`mail-preference-${mail.label}-toggle`}
      data-action="account.mail-preference.toggle"
      data-label={mail.label}
      className={className}
    >
      <FormControlLabel
        control={
          <Switch
            id={`mail-preference-${mail.label}-switch`}
            onChange={clickHandler}
            checked={mail.enabled}
            color="success"
          />
        }
        label={<Typography variant="body">{label}</Typography>}
      />
    </div>
  );
};
